import Enum from "../../../../../../enums/Enum";

const YesNoEnum = new Enum({
        true: {name: "Yes"},
        false: {name: "No"},
});

export default YesNoEnum;